<template>
  <div class="menzhenjiaofeijilu">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length ? '没有更多了' : ''"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.id" class="view-box-container">
        <div class="view-box" :class="item.status==='2' ? 'view-bj' : ''">
          <div v-if="item.jslx !== '1' && item.jslx!=='2'" class="view-text-box">
            <span class="view-item">科室：</span>
            <span class="view-text">{{ item.deptName }}</span>
          </div>
          <div v-if="item.jslx !== '1' && item.jslx!=='2'" class="view-text-box">
            <span class="view-item">就诊医生：</span>
            <span class="view-text">{{ item.doctorName }}</span>
          </div>
          <!-- <div class="view-text-box">
            <span class="view-item">费用名称：</span>
            <span class="view-text">{{item.chargeName}}</span>
          </div> -->
          <div class="view-text-box">
            <!-- <span class="view-item">缴费时间：</span> -->
            <span class="view-item">{{ item.chargeTime }}</span>
            <span class="view-text" style="float:right;margin-right:30px">
              <span v-if="item.status==='0'" class="view-text-box view-text-success">未交费</span>
              <span v-if="item.status==='1'" class="view-text-box view-text-success">缴费成功</span>
              <span v-if="item.status==='2'" class="view-text-box view-text-fail">已作废</span>
            </span>
          </div>
          <!-- <div class="view-text-box">
            <span class="view-item">缴费状态：</span>
            <span class="view-text">
              <span class="view-text-box view-text-success" v-if="item.status==='0'">未交费</span>
              <span class="view-text-box view-text-success" v-if="item.status==='1'">缴费成功</span>
              <span class="view-text-box view-text-fail" v-if="item.status==='2'">已作废</span>
            </span>
          </div> -->
        </div>
        <!-- <div class="box-bottom">
          <div v-if="item.status==='1' || item.status==='2'" class="bom-btn" @click="todzpz(item.id)">电子凭证</div>
          <div class="bom-btn" @click="toMingxi(item.clinicNo)">缴费明细</div>
        </div> -->
      </div>
    </van-list>
    <NoData v-if="!loading && list.length === 0" />
  </div>
</template>

<script>
export default {
  name: 'MenZhenJiaoFeiJiLu',
  // components: {
  //   pdf
  // },
  data() {
    return {
      current: 1,
      pageSize: 10,
      patientIds: '',
      list: [],
      loading: false,
      finished: false
    }
  },
  created() {
    this.list = []
    const userInfo = localStorage.getItem('userInfo')
    this.patientIds = JSON.parse(userInfo).id
    this.getList()
  },
  mounted() {},
  methods: {
    getList() {
      this.loading = true
      const obj = {
        patientIds: this.patientIds,
        current: this.current,
        size: this.pageSize,
        status: '1;2'
      }
      this.$Apis.chargeListPage(obj).then(res => {
        this.loading = false
        if (res.code === 200) {
          const { current, totalPage, list } = res.data
          this.list = [...this.list, ...list]
          this.finished = (totalPage === 0 || current === totalPage)
        } else {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    onLoad() {
      this.current++
      this.getList()
    },
    todzpz(id) {
      // this.$router.push(`/dianzipingzheng?id=${id}`)
      this.$Apis.getEinvoiceDetailsById({ Id: id }).then(res => {
        if (res.code === 200) {
          window.location.href = res.data.dzpjurl
        } else {
          this.$toast(res.message)
        }
      })
    },
    toMingxi(id) {
      this.$router.push(`/jiaofeimingxi?id=${id}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.view-box-container {
  margin: 0.1rem;
    padding: 0.1rem;
    background: #fff;
    border-radius: 0.1rem;
    overflow: hidden;
  // padding: .05rem 0;
  // margin-top: .05rem;
  // margin-bottom: .05rem;
  // background: #ffffff;
  // border-radius: .04rem;
}

.view-item{
    font-size: .17rem;
}

.view-text{
font-size: .17rem;
color: #888888;
// line-height: 39px;
}

.view-bj{
  background: url('/images/yizuofei.png') no-repeat right .2rem top .1rem / .5rem .5rem;
}

.view-box{
  margin-top: .1rem;
}

.view-text-box {
  margin-left: .20rem;
  line-height: 1.2;
  font-size: .14rem;
  margin-bottom: .15rem;
}

.view-text-success {
  font-size: .17rem;
  color: #1078FE;
}

.view-text-fail {
  color: red;
}

.box-right {
  margin-right: .2rem;
}

.box-right .btn {
  background: #1777FF;
  padding: .03rem .05rem;
  border-radius: .015rem;
  font-size: .14rem;
  color: #fff;
  z-index: 999;
}

.box-bottom {
  padding: 0 .15rem .05rem;
  text-align: right;
}

.bom-btn {
  background: #1777FF;
  padding: .03rem .05rem;
  border-radius: .03rem;
  font-size: .14rem;
  color: #fff;
  display: inline-block;
  margin-right: .1rem;
}
</style>
